import styles from './style.module.css';
import bgImage from '../../../assets/webp/CreateAccountBGImage.webp';
import { AppleIcon, GoogleIcon, HidePassword, OpenXLogo, ShowPassword } from '../../../assets';
import { ButtonComponent } from '../../components/button';
import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
// import { baseQueryWithReauth } from '../../../../src/redux/services/userApi';
import { useRegisterUserMutation } from '../../../../src/redux/services/authApi/index';

export const CreateAccount = () => {
  // const [registerUser, { isLoading, isError, error, isSuccess }] = useRegisterUserMutation();
  

  const [full_name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [isLoading, setIsLoading] = useState(false); 
  const [errorMessage, setErrorMessage] = useState('');
  const navigate = useNavigate(); 
  const [registerUser, ] = useRegisterUserMutation();

  const signUp = async () => {
    
    if(isLoading)
      {
        console.log("Still Processing");
        return;
      }
      
          setIsLoading(true);
      
          setErrorMessage('');

    // Basic client-side validation
    if (!full_name || !email || !password) {
      setErrorMessage('• Please fill in all fields.');
      setIsLoading(false);
      return;
    }

    if(!isValidEmail(email))
    {
        console.log("• Email must be a valid email address")
        setErrorMessage("• Email must be a valid email address")
        setIsLoading(false);
        return;
    }


    if (!isChecked) {
      setErrorMessage('• Please agree to the Terms & Conditions and Privacy Policy.');
      setIsLoading(false);
      return;
    }

    const passwordErrors = validatePassword(password);
    
if (passwordErrors.length > 0) {
  setErrorMessage(passwordErrors.join('\n'));
  setIsLoading(false);
  return;
}


    try {
      console.log('Attempting to sign up with:', { name: full_name, email, password });

      const payload  = await registerUser({full_name, email, password}).unwrap();
      const encodedEmail = encodeURIComponent(email);
      const verificationLink = `/verify-user?email=${encodedEmail}`;
      navigate(verificationLink);

    }     catch (err: any) {
        console.error('API error:', err);

        // RTK Query wraps errors in a standard structure
        if (err?.data?.detail) {
          setErrorMessage(`• ${err.data.detail}`);
        console.log('API error:', err);

        } else if (err?.error) {
          setErrorMessage(`• ${err.error}`);
        console.log('API error:', err);

        } else {
          setErrorMessage('• Something went wrong. Please try again.');
        }
      }  finally {
      setIsLoading(false); // End loading
    }
  };

      function isValidEmail(email: string): boolean {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email.trim());
    }

  const validatePassword = (password: string) => {
  const errors: string[] = [];
  if (password.length < 8) {
    errors.push('• Password must be at least 8 characters long');
  }
  if (!/[A-Z]/.test(password)) {
    errors.push('• Password must contain at least one uppercase letter');
  }
  if (!/[a-z]/.test(password)) {
    errors.push('• Password must contain at least one lowercase letter');
  }
  if (!/[0-9]/.test(password)) {
    errors.push('• Password must contain at least one digit');
  }
  if (!/[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(password)) {
    errors.push('• Password must contain at least one special character');
  }
  return errors;
};

  const toggleCheckbox = () => {
    setIsChecked(prev => !prev); 
    // console.log(isChecked);
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className={styles.container}>
      <img className={styles.bgImg} src={bgImage} alt="Gallery Image"></img>
      <div className={styles.entryContainer}>
        <OpenXLogo /* className={styles.icon} */ />
        <div className={styles.headerTxt}>Create Your Account</div>
        <div className={styles.btnCont}>
          <div className={styles.signInBtn}>
            <GoogleIcon /> Sign In
          </div>
          <div className={styles.signInBtn}>
            <AppleIcon /> Sign In
          </div>
        </div>
        <div className={styles.orTxt}>OR</div>
        <form className={styles.form}>
          <div className={styles.field}>
            <label htmlFor="name" className={styles.label}>
              Name
            </label>
            <input type="text" id="name" name="name" className={styles.input} placeholder="John Doe" onChange={(e) => setName(e.target.value)} />
          </div>

          <div className={styles.field}>
            <label htmlFor="email" className={styles.label}>
              Email
            </label>
            <input
              type="email"
              id="email"
              name="email"
              className={styles.input}
              placeholder="johndoe@mail.com"
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>

          <div className={styles.field}>
            <label htmlFor="password" className={styles.label}>
              Password
            </label>
            <div className={styles.inputContainer}>
              <input
                type={showPassword ? 'text' : 'password'}
                id="password"
                name="password"
                className={styles.input}
                placeholder="Enter Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <span className={styles.passwordToggle} onClick={togglePasswordVisibility}>
                {showPassword ? <HidePassword /> : <ShowPassword />}
              </span>
            </div>
          </div>

          {/* <button type="submit" className={styles.button}>Create Account</button> */}
          <div className={styles.errMsg}>{errorMessage}</div>
        </form>

        <div className={styles.terms}>
          <input type="checkbox" className={styles.checkboxInput} checked={isChecked} onChange={toggleCheckbox} />

          <p className={styles.text}>
            Creating an account means you agree to the{' '}
            <a href="/terms" className={styles.link} target="_blank" rel="noopener noreferrer">
              Terms & Conditions
            </a>{' '}
            and{" "} 
            <a href="/privacy" className={styles.link} target="_blank" rel="noopener noreferrer">
              Privacy Policy
            </a>
            .
          </p>
        </div>

        <ButtonComponent 
        buttonName={isLoading ? 'Signing Up...' : 'Sign Up'}
        handleclick={signUp} 
        style={{ 
          marginTop: 40, 
          marginBottom: 36, 
          width: '450px', 
          height: '46px',
          border: 0,
          opacity: isLoading ? 0.5 : 1
          }} />

        <div className={styles.signInCont}>
          Already have an account?
          <Link to="/signIn" style={{ textDecoration: 'none' }}>
            <div className={styles.signIn}>Sign in</div>
          </Link>
        </div>
      </div>
    </div>
  );
};
